
import { UserRoomStateData, SubRoom } from '@/utils/models';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import StatusIcon from '@/components/room/users/StatusIcon.vue';
import RoomsMemberListItem from './RoomsMemberListItem.vue';
@Component({ components: { StatusIcon, RoomsMemberListItem } })
export default class SubRooomListItem extends Vue {
  @Prop() private subroom!: SubRoom;
  @Prop() isEditMode!: boolean;
  get current(): SubRoom {
    return this.subroom;
  }
  get members(): UserRoomStateData[] {
    return this.current?.userStates || [];
  }
  @Emit()
  subroomSelectionChanged(ev: MouseEvent): { rect: any; subroom: SubRoom } {
    let rect = (ev.target as HTMLDivElement).getBoundingClientRect();
    return { rect, subroom: this.subroom };
  }
  @Emit()
  editSubroom(subroom: SubRoom) {}
  @Emit()
  deleteSubroom(subroom: SubRoom) {}
}
